<p>protected works!</p>
